import { render, staticRenderFns } from "./purchased.vue?vue&type=template&id=150044df&scoped=true"
import script from "./purchased.vue?vue&type=script&lang=js"
export * from "./purchased.vue?vue&type=script&lang=js"
import style0 from "./purchased.vue?vue&type=style&index=0&id=150044df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150044df",
  null
  
)

export default component.exports